const { useQuery, gql } = require("@apollo/client");

const FETCH_ODOO_CUSTOMERS = gql`
  query FETCH_ODOO_CUSTOMERS(
    $instance: String!
    $useType: String!
    $ids: [Int]
  ) {
    odooCustomers(instance: $instance, useType: $useType, ids: $ids)
  }
`;

const useOdooCustomers = ({ instance, useType, ids }) => {
  const { loading, error, data } = useQuery(FETCH_ODOO_CUSTOMERS, {
    variables: { instance, useType, ids },
  });
  const odooCustomers = data ? JSON.parse(data.odooCustomers).records : [];
  return { loading, error, odooCustomers };
};

export default useOdooCustomers;
